module.exports = __webpack_public_path__ + "img/racecourse-durbanville-turf.b60c6059.svg";